<template>
  <component v-bind:is="itemType" :item="item" :index="index"></component>
</template>

<script>
  import WorkOrder from './items/WorkOrder.vue';
  import GenericItem from './items/GenericItem.vue';
  import HeaderItem from './items/HeaderItem.vue';

  export default {
    name: 'AgendaItem',
    components: {
      WorkOrder,
      GenericItem,
      HeaderItem,
    },
    props: ['item', 'index'],
    computed: {
      itemType() {
        if (this.item.hasOwnProperty('work_order_id')) {
          return 'WorkOrder';
        }
        return this.item.type;
      },
    },
  };
</script>

<style lang="scss">
  .queue-item__detail--notes {
    padding-left: 1em !important;
  }
</style>
